// Clean Meta Pixel tracking — standard events only
// No custom events, no duplicates, no financial language

type FbqFn = (...args: unknown[]) => void

function getFbq(): FbqFn | undefined {
  return (window as unknown as { fbq?: FbqFn }).fbq
}

function fireStandardPixelEvent(
  eventName: string,
  data?: Record<string, unknown>,
) {
  try {
    const fbq = getFbq()
    if (fbq) {
      fbq('track', eventName, data)
    }
    if (import.meta.env?.DEV) {
      console.log(`[Pixel] ${eventName}`, data)
    }
  } catch {
    // Silently fail — tracking should never break the app
  }
}

/** Fire ViewContent once on landing page load */
export function trackViewContent() {
  fireStandardPixelEvent('ViewContent', {
    content_name: 'Codigo888_Landing',
  })
}

/** Fire InitiateCheckout before redirecting to Shopify */
export function trackInitiateCheckout(value: number, contentName: string) {
  fireStandardPixelEvent('InitiateCheckout', {
    value,
    currency: 'USD',
    content_name: contentName,
  })
}

/**
 * Helper: fire InitiateCheckout then redirect after 150ms
 * Use this on all checkout buttons to ensure pixel fires before navigation.
 */
export function trackAndRedirect(
  value: number,
  contentName: string,
  url: string,
) {
  trackInitiateCheckout(value, contentName)
  setTimeout(() => {
    window.location.href = url
  }, 150)
}
